import { css } from '@emotion/react'
import { spacing } from 'styles/variables'
import * as MQ from 'styles/media-queries'

export const mobileView = css`
  ${MQ.NOT_PHONES} {
    display: none;
  }
`

export const desktopView = css`
  ${MQ.PHONES} {
    display: none;
  }
`

export const contentContainer = css`
  padding: ${spacing(2, 2, 15, 2)};
  padding-top: 140px; /* Account for fixed header height */
  
  /* Add extra bottom padding to account for fixed bottom navigation */
  ${MQ.PHONES} {
    padding-bottom: ${spacing(18)};
  }
`

export const cardsContainer = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(2.5)};
`

export const emptyState = css`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  text-align: center;
  padding: ${spacing(4, 2)};
`

export const loadingMore = css`
  margin-top: ${spacing(2)};
  margin-bottom: ${spacing(2)};
`

export const loadingPlaceholder = css`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${spacing(3, 2)};
  text-align: center;
` 